import React from 'react';
import { useDocViewer } from '~/components/Shared/DocViewer/Context';
import { formatTimestamp, formats } from '~/helpers/dateHelper';

type TDocViewerFieldSignatureProps = {
  field: any;
}

const DocViewerFieldSignature = (props: TDocViewerFieldSignatureProps) => {

  /**
   * Component props:
   * field {object} the signature field
   */
  const { field } = props;

  /**
   * Context vars (see: Context.tsx)
   */
  const { orderDoc, fieldIsSigned } = useDocViewer();

  /**
   * Returns the orderDocSigning object this signature belongs to
   * @returns {object}
   */
  const getSigning = () => orderDoc.signings.find((s: any) => s.id == field.signingId);

  return <React.Fragment>
    <div className="doc-viewer-signature-element">
      <img src={field.signature} className="doc-viewer-signature-image" />
    </div>
    {fieldIsSigned(field) && <div className="doc-viewer-signature-metadata">{formatTimestamp(getSigning().createdTs, formats.SIGNATURE_DATE)}</div>}
  </React.Fragment>
}

export default DocViewerFieldSignature;